module.exports = "/_next/static/images/avatar4-199ce71634d54089ae72509e0c281373.jpg";